import * as React from 'react'
import clsx from 'clsx'
import styles from './index.module.scss'

export interface TooltipArrowProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  classes?: {
    root: string
  }
}

export const TooltipArrow = React.forwardRef<
  HTMLSpanElement,
  TooltipArrowProps
>((props, ref) => {
  const { classes, ...others } = props
  return (
    <span
      ref={ref}
      className={clsx(styles.tooltipArrow, classes?.root)}
      {...others}
    />
  )
})
TooltipArrow.displayName = 'TooltipArrow'
